import { render, staticRenderFns } from "./BarcodeInstructions.vue?vue&type=template&id=4e9dc175&scoped=true"
import script from "./BarcodeInstructions.vue?vue&type=script&lang=js"
export * from "./BarcodeInstructions.vue?vue&type=script&lang=js"
import style0 from "./BarcodeInstructions.vue?vue&type=style&index=0&id=4e9dc175&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9dc175",
  null
  
)

export default component.exports